var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1026,
    height: 293,
    viewBox: "0 0 1026 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.876 267.871C289.876 281.621 278.626 292.871 264.876 292.871H25.124C11.374 292.871 0.124023 281.621 0.124023 267.871V25.509C0.124023 11.759 11.374 0.509003 25.124 0.509003H264.875C278.625 0.509003 289.876 11.759 289.876 25.509V267.871Z",
    fill: "#F2A52B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.467 139.594V88.477H383.282H427.096V95.779V103.082H434.399H441.702V117.687V132.291H434.399H427.096V139.594V146.897H434.399H441.702V161.501V176.106H434.399H427.096V183.409V190.711H383.282H339.467V139.594ZM412.492 117.686V103.081H390.584H368.677V117.686V132.29H390.584H412.492V117.686ZM412.492 161.501V146.897H390.584H368.677V161.501V176.106H390.584H412.492V161.501Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M470.912 124.989V117.686H507.424H543.937V124.989V132.291H551.24H558.543V161.501V190.711H514.728H470.914V183.409V176.106H463.611H456.308V168.803V161.5H463.611H470.914V154.198V146.895H500.124H529.334V139.592V132.289H500.124H470.914V124.989H470.912ZM529.332 168.803V161.5H507.424H485.517V168.803V176.106H507.424H529.332V168.803Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M646.173 103.081V88.477H660.777H675.382V139.594V190.711H631.567H587.753V183.409V176.106H580.45H573.147V154.199V132.291H580.45H587.753V124.989V117.686H616.963H646.173V103.081ZM646.173 154.199V132.291H624.265H602.358V154.199V176.106H624.265H646.173V154.199Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M704.593 124.989V117.686H748.407H792.222V154.199V190.711H784.919H777.616V198.014V205.317H741.103H704.591V198.014V190.711H733.801H763.011V183.409V176.106H733.801H704.591V168.803V161.5H697.288H689.985V146.896V132.291H697.288H704.591V124.989H704.593ZM763.013 146.896V132.291H741.105H719.198V146.896V161.5H741.105H763.013V146.896Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M821.433 124.989V117.686H857.945H894.458V124.989V132.291H901.761H909.064V146.896V161.5H872.55H836.037V168.803V176.106H865.247H894.457V183.409V190.711H857.944H821.432V183.409V176.106H814.129H806.826V154.199V132.291H814.129H821.432V124.989H821.433ZM879.853 139.594V132.291H857.945H836.038V139.594V146.897H857.945H879.853V139.594Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M938.273 154.199V117.686H952.877H967.482V124.989V132.291H974.784H982.087V124.989V117.686H1003.99H1025.9V124.989V132.291H1003.99H982.087V139.594V146.897H974.784H967.482V168.804V190.711H952.877H938.273V154.199Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M234.301 115.497V108.12H227.321V101.121V100.862V97.063V79.868H234.301V65.51H227.329V65.505H234.301V58.216H227.313V44.272H220.031H198.787V48.768V51.23H184.414H177.407H170.064H162.771H145H127.229H119.936H112.593H105.586H91.213V48.768V44.272H69.969H62.687V58.216H55.699V65.505H62.671V65.51H55.699V79.868H62.679V97.063V100.862V101.121V108.12H55.699V115.497H48.711V158.401H55.699V172.365H62.667V179.361H67.737H69.964V186.719H69.972H76.948V194.008H84.318V200.996H84.321H91.309V205.939V208.289H98.29V214.96H105.583V222.333H112.567V229.619V243.9H119.936V250.96H127.233V258.249H134.205H145H155.795H162.767V250.96H170.064V243.9H177.433V229.619V222.333H184.417V214.96H191.71V208.289H198.691V205.939V200.996H205.679H205.682V194.008H213.052V186.719H220.028H220.036V179.361H222.263H227.333V172.365H234.301V158.401H241.289V115.497H234.301Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.229 186.715H127.229V214.956H128.229V186.715Z",
    fill: "#EBEAE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.581 54.573H123.581V61.866H124.581V54.573Z",
    fill: "#EBEAE6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.964 136.747H76.96V108.109H69.964V101.121H62.679V108.12H69.964V136.747Z",
    fill: "#C1C1C3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.322 136.747H76.96V151.097H84.322V136.747Z",
    fill: "#C1C1C3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.282 194.016V200.996H105.583V186.715H98.292V165.365H91.314V151.104H84.321V165.378H91.306V186.719H84.318V194.008V200.996H84.321V194.016H98.282Z",
    fill: "#C1C1C3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.318 179.349H76.948V172.365H69.972V179.361H76.948V186.719H84.318V179.349Z",
    fill: "#C1C1C3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.233 79.875V65.457H127.229V58.221H119.936V58.217V51.229H112.593H105.586V58.221H98.289V65.514H84.317V51.229H69.964L69.969 58.216H69.964V58.218H62.686V65.505H62.671V65.511H55.698V79.868H62.678V97.063V100.862V101.121H69.963V108.109H76.958V136.747H84.32V151.097V151.105H91.313V165.366H98.291V186.716H105.581V200.997H98.28V194.017H84.32V200.997H91.308V205.94V208.29H98.288V214.961H105.581V222.334H112.565H119.93V214.957H126.599H127.226V186.716H127.23H134.214V151.1H127.23V151.089H127.226V93.836H127.23H134.21H134.214V79.914V79.876H127.233V79.875ZM112.593 165.385H108.382H105.582V158.336H108.382H112.593V165.385Z",
    fill: "#1F1C22"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.317 186.719H76.948V194.008H84.317V186.719Z",
    fill: "#1F1C22"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.687 58.217V58.216H55.699V65.505H62.671V58.217H62.687Z",
    fill: "#EBEAE6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.671 58.217H62.671V65.504H63.671V58.217Z",
    fill: "#EBEAE6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.964 51.23H84.318V65.514H98.29V58.221H105.586V51.23H91.213V48.768V44.272H69.969H62.687V58.216H69.964V51.23Z",
    fill: "#EBEAE6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.969 58.216L69.964 51.23V58.216H69.969Z",
    fill: "#EBEAE6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.964 179.361H69.964V186.719H70.964V179.361Z",
    fill: "#1F1C22"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.948 179.361H69.972V186.719H76.948V179.361Z",
    fill: "#1F1C22"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.321 165.378V151.104V151.097H76.96V136.747H69.964V108.12H62.679H55.699V115.497H48.711V158.401H55.699V172.365H62.667V179.361H67.737H69.964H69.972V172.365H76.948V179.349H84.318V186.719H91.306V165.378H84.321Z",
    fill: "#EBEAE6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.229 214.956H126.602H119.932V222.333H112.567V229.619H119.936H127.233V222.333V214.96V214.956H127.229Z",
    fill: "#C1C1C3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M127.233 214.96H134.217V186.715H127.233V214.956V214.96Z",
    fill: "#C1C1C3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134.213 93.836H127.233V151.089H134.213V93.836Z",
    fill: "#C1C1C3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.229 93.836H127.229V151.089H128.229V93.836Z",
    fill: "#C1C1C3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.201 79.913H134.217V93.835H141.201V79.913Z",
    fill: "#C1C1C3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M134.213 58.217H127.229V58.221H127.233V65.457H134.213V58.217Z",
    fill: "#C1C1C3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M128.229 58.221H127.229V65.457H128.229V58.221Z",
    fill: "#C1C1C3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M127.229 51.23H119.936V58.218H127.229V51.23Z",
    fill: "#C1C1C3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.936 229.619H112.567V243.9H119.936V229.619Z",
    fill: "#C1C1C3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.233 243.9H119.936V250.96H127.233V243.9Z",
    fill: "#C1C1C3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M134.206 250.96H127.233V258.249H134.206V250.96Z",
    fill: "#C1C1C3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M108.382 158.336H105.583V165.385H108.382H112.593V158.336H108.382Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M167.416 54.573H166.416V61.866H167.416V54.573Z",
    fill: "#EBEAE6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162.771 58.217V51.23H145H127.229V58.217H134.213V65.457H127.233V79.875H134.217V79.913H141.201V93.836H134.217H134.213V151.089H127.233V151.1H134.217V186.715V214.96H127.233V222.333H145H162.767V214.96H155.783V186.715V151.1H162.767V151.089H155.787V93.836H155.783H148.799V79.913H155.783V79.875H162.767V65.457H155.787V58.217H162.771Z",
    fill: "#EBEAE6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M163.767 186.715H162.767V214.956H163.767V186.715Z",
    fill: "#EBEAE6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M198.694 186.719V165.378H205.679V151.104H198.686V165.365H191.708V186.715H184.417V200.996H191.718V194.016H205.679V200.996H205.682V194.008V186.719H198.694Z",
    fill: "#C1C1C3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M220.028 179.361V172.365H213.052V179.349H205.682V186.719H213.052V179.361H220.028Z",
    fill: "#C1C1C3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M220.036 108.109H213.04V136.747H220.036V108.12H227.321V101.121H220.036V108.109Z",
    fill: "#C1C1C3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M213.041 136.747H205.679V151.097H213.041V136.747Z",
    fill: "#C1C1C3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M227.329 65.51V65.504H227.314V58.217H220.036V58.215H220.031L220.036 51.229H205.683V65.514H191.71V58.221H184.413V51.229H177.406H170.063V58.217V58.221H162.77V65.457H162.766V79.875H155.782V79.913V93.835H155.786H162.766H162.77V151.088H162.766V151.099H155.782V186.714H162.766H162.77V214.955H163.397H170.066V222.332H177.431H184.415V214.959H191.708V208.288H198.688V205.938V200.995H205.676V194.015H191.716V200.995H184.415V186.714H191.705V165.364H198.683V151.103H205.676V151.095V136.745H213.038V108.107H220.034V101.119H227.319V100.86V97.061V79.866H234.299V65.51H227.329ZM184.417 165.385H181.617H177.406V158.336H181.617H184.417V165.385Z",
    fill: "#1F1C22"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M213.052 186.719H205.683V194.008H213.052V186.719Z",
    fill: "#1F1C22"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M227.329 58.217V65.505H234.301V58.216H227.313V58.217H227.329Z",
    fill: "#EBEAE6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M228.314 58.217H227.314V65.504H228.314V58.217Z",
    fill: "#EBEAE6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M191.71 58.221V65.514H205.682V51.23H220.036V58.216H227.313V44.272H220.031H198.787V48.768V51.23H184.414V58.221H191.71Z",
    fill: "#EBEAE6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M220.031 58.216H220.036V51.23L220.031 58.216Z",
    fill: "#EBEAE6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M221.028 179.361H220.028V186.719H221.028V179.361Z",
    fill: "#1F1C22"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220.028 179.361H213.052V186.719H220.028V179.361Z",
    fill: "#1F1C22"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M234.301 115.497V108.12H227.321H220.036V136.747H213.04V151.097H205.679V151.104V165.378H198.694V186.719H205.682V179.349H213.052V172.365H220.028V179.361H220.036H222.263H227.333V172.365H234.301V158.401H241.289V115.497H234.301Z",
    fill: "#EBEAE6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M170.068 222.333V214.956H163.398H162.771H162.767V214.96V222.333V229.619H170.064H177.433V222.333H170.068Z",
    fill: "#C1C1C3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M162.767 186.715H155.783V214.96H162.767V214.956V186.715Z",
    fill: "#C1C1C3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M162.767 93.836H155.787V151.089H162.767V93.836Z",
    fill: "#C1C1C3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M163.767 93.836H162.767V151.089H163.767V93.836Z",
    fill: "#C1C1C3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M155.783 79.913H148.799V93.835H155.783V79.913Z",
    fill: "#C1C1C3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M162.771 58.221V58.217H155.787V65.457H162.767V58.221H162.771Z",
    fill: "#C1C1C3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M163.767 58.221H162.767V65.457H163.767V58.221Z",
    fill: "#C1C1C3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M170.064 51.23H162.771V58.218H170.064V51.23Z",
    fill: "#C1C1C3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M177.433 229.619H170.064V243.9H177.433V229.619Z",
    fill: "#C1C1C3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M170.064 243.9H162.767V250.96H170.064V243.9Z",
    fill: "#C1C1C3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M162.768 250.96H155.795V258.249H162.768V250.96Z",
    fill: "#C1C1C3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M162.767 229.619V222.333H145H127.233V229.619H119.936V243.9H127.233V250.96H134.205V258.249H145H155.795V250.96H162.767V243.9H170.064V229.619H162.767Z",
    fill: "#1F1C22"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M181.618 158.336H177.407V165.385H181.618H184.417V158.336H181.618Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadger);
export default __webpack_public_path__ + "static/media/badger.61ab1462f64997bf1b8be8f0aea58c34.svg";
export { ForwardRef as ReactComponent };